<template>
    <div class="row">
        <div class="small-12 column end">
            <FormView/>
        </div>
    </div>
</template>

<script>
    import FormView from "@/views/FormView";
    export default {
        name: "MainView",
        components: {FormView}
    }
</script>

<style scoped>

</style>